class MMRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-loaded') || !this.dataset.productId) return;
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.load();
    }, { rootMargin: '500px' });
    this.observer.observe(this);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
  }
  async load() {
    this.controller = new AbortController();
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('product_id', this.dataset.productId);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('limit', '8');
    url.searchParams.set('intent', 'related');
    try {
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = doc.querySelector('mm-recommendations');
      // Keep the server-rendered catalog fallback if recommendations are unavailable.
      if (result?.querySelector('.mm-product-tile') && !this.contains(document.activeElement)) {
        this.innerHTML = result.innerHTML;
      }
      this.setAttribute('data-loaded', '');
    } catch (error) {
      if (error.name !== 'AbortError') this.setAttribute('data-fallback', '');
    }
  }
}
if (!customElements.get('mm-recommendations')) customElements.define('mm-recommendations', MMRecommendations);
